import productInstance from '../product/instance'

const deleteAllCategories = () => {
  return productInstance.delete('/categories')
}

export default deleteAllCategories
